import axios from 'axios';
import Logger from './services/Logger';

class HttpClient {
  constructor(baseURL) {
    this.client = axios.create({
      baseURL: baseURL || 'http://localhost:3000/',
    });
  }

  get = async (url, authToken = '') => {
    try {
      return await this.client.get(url, {
        Authorization: authToken,
      });
    } catch (err) {
      Logger.LogError(err);
      return err;
    }
  };

  post = async (url, body = null, authToken = '') => {
    try {
      return await this.client.post(url, body, {
        Authorization: authToken,
      });
    } catch (err) {
      Logger.LogError(err);
      return err;
    }
  };
}

export default HttpClient;
